import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditFormasPagoV11Component } from "./edit-formas-pago-v11/edit-formas-pago-v11.component";

@Component({
  selector: "app-formas-pago-v11",
  templateUrl: "./formas-pago-v11.component.html",
  styleUrls: ["./formas-pago-v11.component.scss"],
})
export class FormasPagoV11Component
  extends SuperClassComponent
{
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditFormasPagoV11Component;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
